import React from 'react';
import PropTypes from 'prop-types';
const classNames = require('classnames');

/**
 * AuthInput Component
 * A styled input component for auth forms that integrates with react-hook-form
 * 
 * @param {Object} props
 * @param {string} props.label - Label text for the input
 * @param {string} props.name - Input name
 * @param {string} props.type - Input type (text, email, etc.)
 * @param {Function} props.register - react-hook-form register function
 * @param {Object} props.errors - Error object from react-hook-form
 * @param {Object} props.validation - Validation rules for react-hook-form
 * @param {string} props.backgroundImage - Background image URL
 * @param {string} props.backgroundPosition - Background image position
 * @param {string} props.placeholder - Placeholder text
 * @param {string} props.className - Additional classes for the input
 */
export const AuthInput = ({ 
    label, 
    name, 
    type = "text",
    register, 
    errors, 
    validation = {},
    backgroundImage,
    backgroundPosition = "4px -35px",
    placeholder = "",
    className = ""
}) => {
    return (
        <div className="mb-3">
            {label && <label>{label}</label>}
            <input 
                style={{
                    backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
                    backgroundPosition: backgroundPosition
                }} 
                type={type} 
                name={name}
                placeholder={placeholder}
                className={classNames("form-control", "auth-input", className, { "is-invalid": errors })} 
                {...register(name, validation)} 
            />
            {errors && (
                <div className="invalid-feedback">
                    {errors.message || (
                        <>
                            {errors.type === 'required' && `${label || 'This field'} is required.`}
                            {errors.type === 'minLength' && `${label || 'This field'} should be at least ${validation.minLength} characters long.`}
                            {errors.type === 'maxLength' && `${label || 'This field'} should be at most ${validation.maxLength} characters long.`}
                            {errors.type === 'pattern' && `${label || 'This field'} format is invalid.`}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

AuthInput.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    register: PropTypes.func.isRequired,
    errors: PropTypes.object,
    validation: PropTypes.object,
    backgroundImage: PropTypes.string,
    backgroundPosition: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
};

export default AuthInput;

